"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterListItem = function FilterListItem(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-row ".concat(props.filter.property)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: props.filter.id,
    type: "checkbox",
    checked: props.filtersState[props.filter.id],
    id: "filterCheckbox-".concat(props.filter.id),
    onChange: function onChange(e) {
      props.onChangeFilter(props.filter, e);
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "filterCheckbox-".concat(props.filter.id)
  }, props.filter.label));
};

FilterListItem.propTypes = {
  filter: _propTypes2["default"].filter.isRequired,
  onChangeFilter: _propTypes2["default"].func.isRequired,
  filtersState: _propTypes["default"].arrayOf(_propTypes["default"].bool).isRequired
};
var _default = FilterListItem;
exports["default"] = _default;